import styles from './../css/LockStatusText.module.css'


function LockStatusText(props) {

    if (props.locked) {
        if (props.statusIndex === 6) {
            return <div className={`${styles.statusText} ${styles.textMuted} ${styles.lockedRow}`}><i className={`fas fa-lock ${styles.lockIcon}`}></i><span>Exercise has been approved.</span></div>
        }
        if (props.statusIndex === 1 || props.statusIndex === 2) {
            return <div className={`${styles.statusText} ${styles.textMuted} ${styles.lockedRow}`}><i className={`fas fa-lock ${styles.lockIcon}`}></i><span>{props.statusIndex === 1 ? 'Viewing only — awaiting rep submission.' : 'Viewing only — submission in progress.'}</span></div>
        }
        if (props.statusIndex === 3 || props.statusIndex === 4) {
            return <div className={`${styles.statusText} ${styles.textMuted} ${styles.lockedRow}`}><i className={`fas fa-lock ${styles.lockIcon}`}></i><span>{props.isElevatedViewer ? 'Ready for your review.' : 'Submitted — awaiting approval.'}</span></div>
        }
        if (props.statusIndex === 5) {
            return <div className={`${styles.statusText} ${styles.textMuted} ${styles.lockedRow}`}><i className={`fas fa-lock ${styles.lockIcon}`}></i><span>Viewing only — returned for revision.</span></div>
        }
        return (
            <div className={`${styles.statusText} ${styles.textMuted} ${styles.lockedRow}`}>
                <i className={`fas fa-lock ${styles.lockIcon}`}></i>
                <span>Exercise is locked.</span>
            </div>
        )
    }

    if (!props.approved) {

        if (props.enableSubmitButton) {
            return (
                <div className={`${styles.statusText} ${styles.textOk}`}>Progress is automatically saved.</div>
            )
        }

        const errors = [
            props.exceedsMaxChangesPerTerritory && `Too many reclassifications: ${props.totalChangesInTerritory} of ${props.totalProfilesInTerritory} profiles changed (cap: ${props.maxChangesPerTerritory}).`,
            props.belowMinChangesPerTerritory    && `Not enough reclassifications: ${props.totalChangesInTerritory} of ${props.totalProfilesInTerritory} profiles changed (min: ${props.minChangesPerTerritory}).`,
            props.exceedsMaxUpgradesPerTerritory && `Too many upgrades: ${props.totalUpgradesInTerritory} profiles upgraded (cap: ${props.maxUpgradesPerTerritory}).`,
            props.exceedsMaxDowngradesPerTerritory && `Too many downgrades: ${props.totalDowngradesInTerritory} profiles downgraded (cap: ${props.maxDowngradesPerTerritory}).`,
            props.exceedsMaxPlannedCallsPerTerritory && `Cannot submit more than ${props?.maxPlannedCallsPerTerritory} planned calls for the territory.`,
            props.belowMinPlannedCallsPerTerritory   && `Cannot submit less than ${props?.minPlannedCallsPerTerritory} planned calls for the territory.`,
            ...(props.perTargetLimitErrorList ?? []),
            ...(props.plannedCallLimitErrorList ?? []),
            ...(props.upgradeDowngradeErrorList ?? []),
        ].filter(Boolean);

        if (errors.length > 0) {
            return (
                <div className={`${styles.statusText} ${styles.textError}`}>
                    {errors.map((e, i) => <div key={i}>{e}</div>)}
                </div>
            )
        }

        return (
            <div className={`${styles.statusText} ${styles.textMuted}`}>Role cannot submit from Open status</div>
        )
    }

    return (
        <div className={`${styles.statusText} ${styles.textMuted}`}>Exercise is now locked for editing</div>
    )
}

export default LockStatusText
